window.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('main-blog-list')) {
    customElements.define(
      'main-blog-list',
      class extends HTMLElement {
        constructor() {
          super();
          // 初始化属性
          this.visibleTimestamps = new Map();
          this.processedArticles = new Set();
          this.observer = null; // 添加 observer 属性
        }
        connectedCallback() {
          this.init();
          const swiper = this.querySelector('.recommend-swiper');
          if (swiper) {
            this.initRecommendProducts();
          }
          const blogListSwiper = this.querySelector('.blog-list-item-swiper');
          if (blogListSwiper) {
            this.initBlogListSwiper();
          }
          this.initTabsBackgroundChange(); // 新增：初始化 tabs 背景色变化
          this.initTabFocus(); // 新增：初始化 tab 聚焦功能
        }

        resetAndInit(container) {
          // 断开之前的观察者
          if (this.observer) {
            this.observer.disconnect();
          }

          // 重置状态
          this.visibleTimestamps = new Map();
          this.processedArticles = new Set();

          // 重置所有卡片状态
          const cards = container.querySelectorAll('.blog-card');
          cards.forEach((card) => {
            // 移除可见类
            card.classList.remove('visible');

            // 重置图片状态
            const img = card.querySelector('img');
            if (img) {
              const currentSrc = img.src;
              const dataSrc = img.dataset.src;

              // 如果没有 data-src 属性，先保存当前的 src
              if (!dataSrc && currentSrc) {
                img.dataset.src = currentSrc;
              }

              // 清除当前的 src，这样图片会重新加载
              if (currentSrc) {
                img.removeAttribute('src');
              }
            }
          });

          // 重新初始化观察者
          this.initObserver(container);
        }
        initObserver(container) {
          this.observer = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                const article = entry.target;

                if (entry.isIntersecting) {
                  if (!this.visibleTimestamps.has(article)) {
                    this.visibleTimestamps.set(article, Date.now());

                    // 立即加载图片
                    const img = article.querySelector('img');
                    if (img && img.dataset.src) {
                      img.src = img.dataset.src;
                      img.removeAttribute('data-src');
                    }

                    // 延迟添加可见类
                    const delay = Math.min(this.visibleTimestamps.size * 100, 200);
                    setTimeout(() => {
                      article.classList.add('visible');
                      this.processedArticles.add(article);
                    }, delay);
                  }
                }
              });
            },
            {
              root: null,
              rootMargin: '50px',
              threshold: 0.1,
            }
          );

          // 开始观察容器内的所有文章元素
          const articleItems = container.querySelectorAll('.blog-card');
          articleItems.forEach((article) => {
            this.observer.observe(article);
          });
        }
        init() {
          const allGrids = this.querySelectorAll('.blog-grid');
          allGrids.forEach((grid) => {
            this.initObserver(grid);
          });
        }
        processVisibleArticles() {
          const sortedEntries = Array.from(this.visibleTimestamps.entries())
            .sort((a, b) => a[1] - b[1])
            .filter(([article]) => !this.processedArticles.has(article));

          sortedEntries.forEach(([article], index) => {
            const delay = Math.min(index * 100, 500);
            setTimeout(() => {
              article.classList.add('visible');
              this.processedArticles.add(article);
            }, delay);
          });
        }
        // 推荐产品
        initRecommendProducts() {
          const swiper = this.querySelector('.recommend-swiper');
          const swiperWrapper = this.querySelector('.recommend-swiper-wrapper');
          const swiperSlides = swiperWrapper.querySelectorAll('.recommend-swiper-slide');
          const scrollbarDom = this.querySelector('.swiper-scrollbar');
          swiper.classList.add('swiper');
          swiperWrapper.classList.add('swiper-wrapper');
          swiperSlides.forEach((slide) => {
            slide.classList.add('swiper-slide');
          });
          this.recommendSwiper = new Swiper(swiper, {
            slidesPerView: 'auto',
            freeMode: false,
            allowTouchMove: true, // 启用触摸滑动
            spaceBetween: 24,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            simulateTouch: true,
            touchRatio: 1,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              1201: {
                spaceBetween: 24,
              },
              1200: {
                spaceBetween: 16,
              },
              0: {
                spaceBetween: 16,
              },
            },
            scrollbar: {
              el: scrollbarDom,
              draggable: true,
            },
          });
        }
        initBlogListSwiper() {
          const swipers = this.querySelectorAll('.blog-list-item-swiper');

          swipers.forEach((swiper, index) => {
            if (!swiper) return;

            new Swiper(swiper, {
              slidesPerView: 'auto',
              freeMode: false,
              allowTouchMove: true,
              spaceBetween: 16,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              loop: false,
              simulateTouch: true,
              touchRatio: 1,
              speed: 300,

              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
          });
        }
        /**
         * 监听 tabs 吸顶状态，动态改变 wrapper 背景色
         */
        initTabsBackgroundChange() {
          const tabs = this.querySelector('.main-blog-list-tabs');
          const wrapper = this.querySelector('.main-blog-list-tabs-wrapper');
          if (!tabs || !wrapper) return;

          // 初始化背景色
          wrapper.style.backgroundColor = '#f5f5f5';
          wrapper.style.transition = 'background-color 0.2s ease';
          wrapper.style.zIndex = '1';

          let ticking = false;

          const updateBackground = () => {
            const wrapperRect = wrapper.getBoundingClientRect();
            const isSticky = wrapperRect.top <= 0;
            const isDesktop = window.innerWidth > 960;

            if (isSticky) {
              wrapper.style.backgroundColor = '#ffffff';
              wrapper.style.zIndex = '101';
              if (window.innerWidth <= 960) {
                wrapper.style.boxShadow = '0px 7px 29px 0px rgba(100, 100, 111, 0.16)';
              }
              if (isDesktop) {
                tabs.style.padding = '10px 20px 16px 20px';
              } else {
                tabs.style.padding = '10px 0px 16px 0px';
              }
            } else {
              wrapper.style.backgroundColor = '#f5f5f5';
              wrapper.style.boxShadow = 'none';
              wrapper.style.zIndex = '1';

              // 只有桌面端才恢复 padding
              if (isDesktop) {
                tabs.style.padding = '20px';
              } else {
                tabs.style.padding = '0px';
              }
            }

            ticking = false;
          };

          const onScroll = () => {
            if (!ticking) {
              requestAnimationFrame(updateBackground);
              ticking = true;
            }
          };

          const onResize = () => {
            // 立即更新，不等待 requestAnimationFrame
            const wrapperRect = wrapper.getBoundingClientRect();
            const isSticky = wrapperRect.top <= 0;
            const isDesktop = window.innerWidth > 960;

            if (isSticky) {
              wrapper.style.backgroundColor = '#ffffff';
              // 只有桌面端才改变 padding
              if (isDesktop) {
                tabs.style.padding = '10px 20px 16px 20px';
              }
            } else {
              wrapper.style.backgroundColor = '#f5f5f5';
              // 只有桌面端才恢复 padding
              if (isDesktop) {
                tabs.style.padding = '20px';
              }
            }
          };

          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onResize);

          // 初始化时立即检查一次
          updateBackground();
        }
        /**
         * 初始化 tab 聚焦功能
         */
        initTabFocus() {
          const tabs = this.querySelectorAll('.tab-item');
          const blogItems = this.querySelectorAll('.blog-list-item');
          if (!tabs.length || !blogItems.length) return;

          // 默认聚焦第一个 tab
          this.focusTab(tabs[0]);

          // 点击 tab 切换聚焦
          tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
              e.preventDefault();
              this.focusTab(tab);

              // 滚动到对应的 blog 区域
              const targetId = tab.getAttribute('data-tab');
              const targetElement = this.querySelector(`#${targetId}`);
              if (targetElement) {
                const wrapperTop = this.querySelector('.main-blog-list-tabs-wrapper').offsetTop;
                const elementTop = targetElement.offsetTop;
                const scrollTop = elementTop - wrapperTop - 20; // 20px 偏移
                window.scrollTo({
                  top: scrollTop,
                  behavior: 'smooth',
                });
              }
            });
          });

          // 监听滚动，自动聚焦对应的 tab
          let ticking = false;
          const onScroll = () => {
            if (!ticking) {
              requestAnimationFrame(() => {
                this.updateTabFocusOnScroll();
                ticking = false;
              });
              ticking = true;
            }
          };

          window.addEventListener('scroll', onScroll, { passive: true });

          // 初始化时检查一次
          this.updateTabFocusOnScroll();
        }

        /**
         * 聚焦指定的 tab
         */
        focusTab(targetTab) {
          const tabs = this.querySelectorAll('.tab-item');

          // 移除所有 active 状态
          tabs.forEach((tab) => tab.classList.remove('active'));

          // 激活目标 tab
          targetTab.classList.add('active');

          // 直接操作目标 underline，避免闪烁
          const targetUnderline = targetTab.querySelector('.tab-underline');
          if (targetUnderline) {
            // 使用 opacity 和 transform 实现平滑切换，避免 display 闪烁
            const allUnderlines = this.querySelectorAll('.tab-underline');
            allUnderlines.forEach((underline) => {
              if (underline === targetUnderline) {
                underline.style.opacity = '1';
                underline.style.transform = 'scaleX(1)';
              } else {
                underline.style.opacity = '0';
                underline.style.transform = 'scaleX(0)';
              }
            });
          }

          // 移动端居中显示
          this.centerTabOnMobile(targetTab);
        }

        /**
         * 移动端居中显示 tab
         */
        centerTabOnMobile(targetTab) {
          const tabsContainer = this.querySelector('.main-blog-list-tabs');
          if (!tabsContainer || window.innerWidth > 960) return;

          const containerRect = tabsContainer.getBoundingClientRect();
          const tabRect = targetTab.getBoundingClientRect();
          const containerCenter = containerRect.width / 2;
          const tabCenter = tabRect.left - containerRect.left + tabRect.width / 2;
          const scrollOffset = tabCenter - containerCenter;

          // 平滑滚动到中心位置
          tabsContainer.scrollTo({
            left: tabsContainer.scrollLeft + scrollOffset,
            behavior: 'smooth',
          });
        }

        /**
         * 根据滚动位置更新 tab 聚焦
         */
        updateTabFocusOnScroll() {
          const blogItems = this.querySelectorAll('.blog-list-item');
          const tabs = this.querySelectorAll('.tab-item');
          const wrapper = this.querySelector('.main-blog-list-tabs-wrapper');

          if (!blogItems.length || !tabs.length || !wrapper) return;

          const viewportHeight = window.innerHeight;

          // 找到当前在视口中的 blog 区域
          let activeBlogId = null;

          blogItems.forEach((blogItem) => {
            const blogId = blogItem.getAttribute('id');
            const rect = blogItem.getBoundingClientRect();
            const blogTop = rect.top;
            const blogBottom = rect.bottom;

            // 如果 blog 区域在视口中，或者滚动位置接近该区域
            if (blogTop <= viewportHeight * 0.3 && blogBottom >= viewportHeight * 0.3) {
              activeBlogId = blogId;
            }
          });

          // 如果找到了活跃的 blog，聚焦对应的 tab
          if (activeBlogId) {
            const targetTab = this.querySelector(`[data-tab="${activeBlogId}"]`);
            if (targetTab && !targetTab.classList.contains('active')) {
              this.focusTab(targetTab);
            }
          }
        }
      }
    );
  }
});
